export enum DocumentCategories {
  CONTRACT = '1',
  INVOICE = '2',
  ID = '3',
  WORK_POST_FILE = '4',
  BANKING_MANDATE = '5',
  STUDENT_INSCRIPTION_PROOF = '6',
  VCA = '7',
  MEDICAL_CHECK = '8',
  SAFETY_PASSPORT = '9',
  BANK_CARD = '10',
  DRIVING_LICENCE = '11',
  WORK_PERMIT = '12',
  CONFIRMATION_SHEET = '13',
  PARTNERSHIP_AGREEMENT = '14',
  SHARED_FILES = '15',
  DEVIATION_REGISTER = '16',
  SOCIAL_DOCUMENT = '17',
  INDIVIDUAL_ACCOUNT = '18',
  VACATION_CERTIFICATE = '19',
  EMPLOYMENT_CERTIFICATE = '20',
  PAYSLIP = '21',
  FISCAL_FILE = '22',
  INTENTION_DECLARATION = '23',
  ABSENCE_CERTIFICATE = '24',
  DRIVER_CARD = '25',
  C4 = '26',
  CV = '27',
  CODE_95 = '28',
  RESIDENCE_CARD = '29',
  BURDEN_OF_PROOF_EMPLOYEE = '30',
  BURDEN_OF_PROOF_EMPLOYER = '31',
  CERTIFICATE_OF_GOOD_CONDUCT = '32',
  A1_DECLARATION = '33',
}
